import React from 'react';
import Card from './Generic/Card';
import LoadingSpinner from './Generic/LoadingSpinner';
import { 
    PlusCircle as AddIcon,
    Trophy as AchievementIcon,
    PencilSquare as EditIcon
} from './Generic/Icons';
import useAchievementOptions from '../Hooks/useAchievementOptions';
import './AchievementsCard.scss';
import SearchForm from './SearchForm';
import HookedAchievementModal from './AchievementHookedModal';
import { useLocation, useNavigate } from 'react-router';
import useConstant from '../Provider/ConstantContext';

export default function AchievementsDetails(props) {
    const location = useLocation();
    const navigate = useNavigate();

    const [QSearch, setQSearch, formState, setFormState] = React.useMemo(() => {
        const queryParams = new URLSearchParams(location.search);
        const search = queryParams.get("q") || "";
        const setSearch = (change) => {
            if (change) queryParams.set("q", encodeURIComponent(typeof change === "function"? change(search) : change));
            else queryParams.delete("q");
            navigate("?" + queryParams);
        }
        const formState = {
            abcId: queryParams.get("a"),
            roleId: queryParams.get("r")
        };
        const setFormState = (change) => {
            const state = typeof change === "function"? change(formState) : change;
            if (state?.abcId) queryParams.set("a", encodeURIComponent(state.abcId));
            else queryParams.delete("a");
            if (state?.roleId) queryParams.set("r", encodeURIComponent(state.roleId));
            else queryParams.delete("r");
            navigate("?" + queryParams);
        }
        return [search, setSearch, formState, setFormState];
    }, [location, navigate]);
    
    const [search, setLocalSearch] = React.useState(QSearch);
    const setSearch = React.useCallback((value) => {
        setLocalSearch(value);
        setQSearch(value);
    }, [setLocalSearch, setQSearch]);

    const [options, loading] = useAchievementOptions({search});
    const { Descriptions } = useConstant();
    
    return (
        <Card
            title="Your Achievement Statements"
            description={Descriptions['achievement']}
            classNames={{body: "position-relative"}}
            {...props}
        >
            <div className="d-flex flex-row justify-content-start align-items-center gap-3 mb-3">
                <SearchForm 
                    className="flex-grow-1" 
                    placeholder="Search Achievements..."
                    search={search}
                    setSearch={setSearch}
                />
                <HookedAchievementModal 
                    formState={formState}
                    setFormState={setFormState}
                    onClick={() => {
                        setFormState({ abcId: "new-achievement"})
                    }}
                    triggerName={<><AddIcon className="icon"/> Add Achievements</>}
                />
            </div>
            <div className="d-flex flex-column gap-3 px-2">
                {loading? <LoadingSpinner/> : options.filter(option => Array.isArray(option.options) && option.options.length).map(option => {

                    return (
                        <div key={option.key}>
                            <div className='d-flex flex-row flex-nowrap align-items-center gap-2' >
                                <div className="flex-grow-1">{option.label}</div>
                                <button type="button" className="icon-button" onClick={() => setFormState({
                                    roleId: option.key
                                })}>
                                    <EditIcon className="icon me-0"/>
                                </button>
                            </div>
                            <ul className="achievements-list">
                                {option.options.map(({label, value}) => {
                                    return (
                                        <li key={value}
                                            className='d-flex flex-row flex-nowrap align-items-center gap-2'
                                        >
                                            <AchievementIcon width="24" height="24" className="icon"/>
                                            <div className="achievement-detail fs-medium">{label}</div>
                                            <button type="button" className="icon-button" onClick={() => setFormState({
                                                abcId: value
                                            })}>
                                                <EditIcon className="icon me-0"/>
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    );
                })}
            </div>
            
        </Card>
    ); 
}